import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom"; 
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from '@mui/icons-material/Add';
import CircularProgress from '@mui/material/CircularProgress';
import { isEmail } from 'validator';
import useWindowDimensions from "../../../Hooks/useWindowDimensions";

import { event } from "react-ga";

const BookkeepingInvite = (props) => {

  const { windowWidth } = useWindowDimensions();
  let navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const [isSaving, setIsSaving] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [onResultsPage, setOnResultsPage] = useState(false);

  // const [list, setList]                     = useState([]);
  const [invitees, setInvitees] = useState([]);
  const [firstRowName, setFirstRowName] = useState("");
  const [firstRowEmail, setFirstRowEmail] = useState("");
  const [checkBoxIp, setcheckBoxIp] = useState();

  useEffect(() => {
    if (location.pathname.includes("results")) {
      setOnResultsPage(true);
    } else {
      setOnResultsPage(false);
    }
  }, [location, location.pathname]);

  useEffect(() => {
    let invitee = [{
      id: 1,
      name: "",
      email: "",
      showFullName: false,
      showEmail: false
    }]
    setInvitees(invitee);
    // document.body.style.backgroundColor = "#292829";
  }, []);

  // fullNameRegex allows letters, diacritics, spaces, single quotes, hyphens. needs one space so requires at least 2 words
  const fullNameRegex = /^([A-Za-zÀ-ÖØ-öø-ÿ'-]+ +)+[A-Za-zÀ-ÖØ-öø-ÿ'-]+$/;

  const disableInviteBtn = () => {
    setIsDisabled(false);
    invitees.forEach(invitee => {
      if (!invitee?.name?.length || !invitee?.email?.length) {
        setIsDisabled(true);
      }
    });
  }

  const checkFormValid = () => {
    if (invitees.length > 0) {
      let valid = true;
      invitees.forEach(invitee => {
        if (!fullNameRegex.test(invitee?.name?.trim()) || !isEmail(invitee?.email?.trim())) {
          valid = false;
        }
      });
      setIsFormValid(valid);
    }  
  }

  const submitToApi = (member) => {

    setIsSaving(true);
    const payload = {
      members: member
    }

    fetch(process.env.REACT_APP_API_URI + '/v1/assessment/share/' + id, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(response => {
      return response.json();
    }).then(data => {
      if (data.status === "success") {
        if (onResultsPage) {
          props.setShowInvitePageOnResultsPage(false);
          props.setShowInviteSuccessOnResultsPage(true);
        } else {
          navigate("/bookkeeping/invite-team-thanks/" + id, { replace: true });
        }
      } else {
        setIsSaving(false);
        // setOpenSnackbar(true);
      }
    }).catch((err) => {
      setIsSaving(false);
      console.error("Failed to send invites...", err);
    })

  }


  const addBtnDisabled = () => {

    let isAddBtnDisabled = false;
    invitees.forEach(invitee => {
      if (!invitee?.name?.length) {
        isAddBtnDisabled = true;
      }
      if (!invitee?.email.length) {
        isAddBtnDisabled = true;
      }
    });

    return isAddBtnDisabled
  }

  // console.log("invitees", invitees);

  const handleSubmit = () => {

    setIsSaving(true);

    let formHasError = false;
    invitees.forEach(invitee => {
      if (!fullNameRegex.test(invitee.name?.trim())) {
        invitee.showFullName = true;
        formHasError = true;
      }
      if (!isEmail(invitee.email?.trim())) {
        invitee.showEmail = true;
        formHasError = true;
      }
    });

    if (formHasError) {
      setTimeout(() => { setIsSaving(false); }, 500);
    } else if (!formHasError && isFormValid) {
      submitToApi(invitees);
    }

  }

  const deletePerson = (p) => {
    setInvitees(invitees.filter((person) => {
      return person.id !== p
    }));
  };

  const addPerson = () => {
    if (!addBtnDisabled()) {
      let id = 2;
      if (invitees.length > 0) {
        id = invitees[invitees.length - 1].id + 1;
      }

      let person = {
        id: id,
        name: "",
        email: ""
      }
      setInvitees([...invitees, person]);
    }
    checkFormValid();
  };

  const updateName = (e, id) => {
    let currentMember = invitees.find(function (obj) { return obj.id == id; });
    currentMember.name = e.target.value;
    disableInviteBtn();
    checkFormValid();
  }

  const updateEmail = (e, id) => {
    let currentMember = invitees.find(function (obj) { return obj.id == id; });
    currentMember.email = e.target.value;
    disableInviteBtn();
    checkFormValid();
  }

  const showButton = () => {
    if (isSaving && isFormValid) {
      // return <div className="button-progress"><CircularProgress style={{ color: '#FFFFFF' }} size={23} /></div>
      return "SENDING INVITE...";

    }
    return "SEND INVITE";
  }

  const removeError = (id, field, e) => {

    // change active input field title color 
    if (e.target.closest(".form-detail")) {
      document.body.querySelectorAll(".input-title").forEach(elm => elm.style.color = "#27282A")
      e.target.closest(".form-detail").querySelector(".input-title").style.color = "#27282A";
    }

    let newinvitees = [];
    invitees.forEach(invitee => {
      if (field == "fullName" && invitee.id == id) {
        invitee.showFullName = false;
      }
      if (field == "email" && invitee.id == id) {
        invitee.showEmail = false;
      }
      newinvitees.push(invitee);
    });
    setInvitees(newinvitees);
  }

  const handleCheckBoxIp = (e) => {
    setcheckBoxIp(e.target.checked)
  }


  return (
    <>
      <div className="container invite">
        <div className="details-container">
          <h1>Champion greater financial discipline</h1>
          {/* <p>We're thrilled you're sharing the Financial Discipline Assessment! Your invitations will go a long way in aligning the Church’s financial footprints with its mission and vision.</p> */}
          <p> Your invitation can go a long way in aligning the Church’s financial footprints with its mission and vision.</p>
          {/* <p>Their results will populate your dashboard and as the Head of School, you'll see how the entire leadership team of the Board + Head of School aligns individually and collectively.</p> */}

          {
            invitees.map((data, index) => (
              <>
                <div className="form _form" key={data.id}>
                  <div className="invite-number">{index + 1}.</div>
                  <div className="form-detail">
                    <p className="input-title">Full name <span style={{ color: "red" }}>*</span></p>
                    <TextField hiddenLabel placeholder="E.g. John Zebedee" onFocus={(e) => { removeError(data.id, "fullName", e) }} onChange={(e) => { updateName(e, data.id) }} fullWidth variant="standard" size="normal" InputProps={{ disableUnderline: true }} className="invite-field" />
                    {
                      data.showFullName ?
                        <div className="error-text">Please enter the full name</div>
                        : null
                    }
                  </div>
                  <div className="form-detail">
                    <p className="input-title">Email <span style={{ color: "red" }}>*</span></p>
                    <TextField hiddenLabel placeholder="E.g. johnz@petra.church" onFocus={(e) => { removeError(data.id, "email", e) }} onChange={(e) => { updateEmail(e, data.id) }} fullWidth variant="standard" size="normal" InputProps={{ disableUnderline: true }} className="invite-field" type="email" />
                    {
                      data.showEmail ?
                        <div className="error-text">Please enter a valid email ID</div>
                        : null
                    }
                  </div>
                  {data.id != 1 ?
                    <div className="delete-btn">
                      <div onClick={() => deletePerson(data.id)}>
                        <DeleteIcon className="delete-icon" />
                      </div>
                    </div>
                    : null
                  }
                </div>
                <hr />
              </>
            ))
          }

          <div className="invite-another-person">
            <div className="invite-another">

              <div className="form_icons--icon">
                <Button onClick={addPerson} className="add-btn" disabled={isDisabled}>
                  <AddIcon className="invite-another-icon" />ADD&nbsp;
                  {/* + Add&nbsp; */}
                </Button>
              </div>
            </div>
          </div>

          <div className="buttons">
            {windowWidth <= 830 && <Button onClick={addPerson} className="add-btn" disabled={isDisabled}>
              <AddIcon className="invite-another-icon" />ADD&nbsp;
            </Button>}
            <Button style={isSaving ? { opacity: "0.7" } : { opacity: "1" }} className="cta-btn" disabled={isDisabled} onClick={() => handleSubmit()}>{showButton()}</Button>
          </div>
          {/* <div className="include-results-confirmation">
            <input type="checkbox" onChange={handleCheckBoxIp} />
            <h4>Include my results in the email.</h4>
            <label htmlFor="includeResultsCheckbox">
            <input type="checkbox" id="includeResultsCheckbox" onChange={handleCheckBoxIp} />
              Include my results in the email.
            </label>
          </div> */}
        </div>
      </div>
    </>
  );

};

export default BookkeepingInvite;

